<div class="agpr-date-filter u-mdPadding" [ngClass]="styleClass" *ngIf="options">
    <div class="ui-inputgroup">
        <p-select #dropdown
            [styleClass]="dropdownStyleClass"
            [inputId]="id + '.dropdown'"
            [panelStyleClass]="dropdownStyleClass"
            [agprCustomDropdownLabel]="calendarIconTemplate"
            [options]="options"
            [(ngModel)]="selectedDateQuery"
            (onChange)="onSelectedOptionChange($event)"
            pTooltip="{{dateTimeFilter}}"
            tooltipPosition="top"
        >
        </p-select>
        <p-datepicker
            #calendar
            class="agpr-dateFilter-calendar"
            [(ngModel)]="dates"
            [defaultDate]="defaultDate"
            [selectionMode]="selectionMode"
            [inputStyleClass]="inputStyleClass"
            [inputId]="id + '.calendar'"
            [name]="name"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [dateFormat]="dateFormat"
            [inline]="inline"
            [showOtherMonths]="showOtherMonths"
            [selectOtherMonths]="selectOtherMonths"
            [showIcon]="showIcon"
            [showOnFocus]="showOnFocus"
            [icon]="icon"
            [appendTo]="appendTo"
            [shortYearCutoff]="shortYearCutoff"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [disabledDates]="disabledDates"
            [disabledDays]="disabledDays"
            [monthNavigator]="monthNavigator"
            [yearNavigator]="yearNavigator"
            [yearRange]="yearRange"
            [showTime]="showTime"
            [hourFormat]="hourFormat"
            [locale]="locale"
            [timeOnly]="timeOnly"
            [dataType]="dataType"
            [required]="required"
            [tabindex]="tabindex"
            [showSeconds]="showSeconds"
            [stepHour]="stepHour"
            [stepMinute]="stepMinute"
            [stepSecond]="stepSecond"
            [maxDateCount]="maxDateCount"
            [showButtonBar]="showButtonBar"
            [todayButtonStyleClass]="todayButtonStyleClass"
            [clearButtonStyleClass]="clearButtonStyleClass"
            [baseZIndex]="baseZIndex"
            [autoZIndex]="autoZIndex"
            [panelStyleClass]="panelStyleClass"
            [keepInvalid]="keepInvalid"
            [hideOnDateTimeSelect]="hideOnDateTimeSelect"
            [readonlyInput]="readonlyInput"
            (onSelect)="emitOnSelect($event)"
            (onBlur)="emitOnBlur($event)"
            (onFocus)="emitOnFocus($event)"
            (onClose)="emitOnClose($event)"
            (onTodayClick)="emitOnTodayClick($event)"
            (onClearClick)="emitOnClearClick($event)"
            (onMonthChange)="emitOnMonthChange($event)"
            (onYearChange)="emitOnYearChange($event)"
        >
        </p-datepicker>
    </div>
</div>
<ng-template #calendarIconTemplate>
        <span class="u-srOnly">
            {{ calendarIcon_sr }}
        </span>
        <span class="fa-duotone fa-regular fa-calendar-range"
            aria-hidden="true">
        </span>
</ng-template>
